import { Card, Group, Stack } from '@mantine/core';
import type { CeleryTask } from '@repo/api-codegen';
import { Badge, Icon, Text } from '@repo/foundations';
import dayjs from 'dayjs';
import { useStyles } from '../InspectCeleryPage.styles';

interface TaskCardProps {
	task: CeleryTask;
	onClick: () => void;
}

export function TaskCard({ task, onClick }: TaskCardProps) {
	const { classes, theme } = useStyles();

	const getStatusVariant = (status: string) => {
		switch (status.toLowerCase().trim()) {
			case 'active':
				return 'success';
			case 'reserved':
				return 'info';
			default:
				return 'default';
		}
	};

	const formatTimeStart = (timeStart: number) =>
		dayjs.unix(timeStart).format('HH:mm:ss');

	return (
		<Card
			className={`${classes.card} ${classes.hoverCard}`}
			bg={theme.other.getColor('surface/primary/default')}
			style={{ cursor: 'pointer', width: '100%', maxWidth: '300px' }}
			onClick={onClick}
		>
			<Stack spacing="sm">
				<Group spacing="xs">
					<Icon name="code" color="icon/primary/default" size="md" />
					<Text size="sm" weight="semibold" color="text/primary/default">
						{task.name}
					</Text>
				</Group>

				<Stack spacing="xs">
					<Group position="apart">
						<Badge variant={getStatusVariant(task.status)} size="sm">
							{task.status}
						</Badge>
						<Text size="xs" color="text/secondary/default">
							{'Started: ' +
								(task.time_start ? formatTimeStart(task.time_start) : 'N/A')}
						</Text>
					</Group>
				</Stack>
			</Stack>
		</Card>
	);
}
